import React, { HTMLAttributes, ReactElement, ReactNode } from 'react';
import './Title.css';

export interface ITitleProps extends HTMLAttributes<any> {
	tag?: 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';
	styledAs?: 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | '';
	spanTitle?: string | ReactElement | ReactElement[];
	spanClass?: string;
	showHr?: boolean;
	align?: 'center' | 'left';
	children?: ReactNode;
	className?: string;
	hrClass?: string;
	verticalBar?: boolean;
}

const Title = ({
	tag = 'h1',
	className = '',
	spanTitle = '',
	spanClass = '',
	styledAs = '',
	children,
	showHr = false,
	align = 'left',
	hrClass = '',
	verticalBar,
	...rest
}: ITitleProps) => {
	const Tag: ITitleProps['tag'] = tag;
	return (
		<Tag
			className={`Title grid ${verticalBar ? 'Title__verticalBar pl-4 text-left' : align === 'center' ? 'text-center' : align} ${styledAs} ${className}`}
			{...rest}
		>
			<span>{children}</span>
			{spanTitle && (
				<>
					<span
						className={`font-normal block Title__sub_heading${
							tag !== 'span' ? `--${tag}` : ''
						} ${spanClass}`}
					>
						{spanTitle}
					</span>
				</>
			)}
			{!verticalBar && showHr && (
				<span aria-hidden='true' tabIndex={-1} className={`Title__hr border-none bg-green-silver-tree w-20 Title__hr--${align} ${hrClass}`}></span>
			)}
		</Tag>
	);
};

export default Title;
